/**
 * Who is behind the project and where it points people.
 *
 * They live here, and not inline, because they appear in several places at
 * once — the header menu and both legal pages — and the legal ones name the
 * address as the way to exercise data-protection rights. Two copies of a
 * promise is one copy too many.
 */

/** Person responsible, as the legal pages must name them. */
export const AUTHOR = 'Oscar Ruiz';

/** Their profile, so the name is verifiable and not just a string. */
export const AUTHOR_GITHUB = 'https://github.com/oscaruiz/';

/** The project's source code. */
export const GITHUB = 'https://github.com/oscaruiz/playas-cantabria';

/** Contact address, published in the menu and in both legal pages. */
export const EMAIL = 'playascantabriapp@gmail.com';
